export default __webpack_public_path__ + "assets/medical-request-component.5570d381.svg";